import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import Arcs from "../../assets/Arcs";
import Tile from "../../assets/Tile";
import TileGlyph from "../../assets/TileGlyph";
import AmountPill from "../AmountPill";
import getTierLevel from "../TierCard/getTierLevel";

type Props = {
  id: string;
};

const HistoryItem: FC<Props> = ({ id }) => {
  const {
    state: { history, tiers, currentTier, currentPoints },
  } = useRewardCenter();
  const entry = history?.entries?.find((item) => item.id === id);
  if (!entry) return null;

  const tier = tiers.find((item) => item.id === currentTier);
  const level = tier ? getTierLevel(tier, currentPoints).level : undefined;

  return (
    <div
      data-slot="history-item"
      className="relative flex items-center gap-3 overflow-hidden rounded-2xl border-t border-t-foreground/5 bg-card p-3 shadow-md"
    >
      <Arcs variant="card" />
      <Tile type={entry.type} size="34">
        <TileGlyph type={entry.type} level={level} tierName={tier?.name} />
      </Tile>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <p className="font-semibold text-foreground text-sm">{entry.label}</p>
        <p className="text-muted-foreground text-xs">{entry.date}</p>
      </div>
      <AmountPill
        amount={`+ ${entry.amount}`}
        tone="glass"
        className="pr-2.5 text-sm"
      />
    </div>
  );
};

export default HistoryItem;
